export const noCaseStringComparer = (valueA, valueB) => {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};